import React from "react";
import "./tierHeader.css";

import { NavLink } from "react-router-dom";

function tierHeader(tier) {
    return (
        <nav className="tierHeader">
        <div className="container">
            <h1>{tier}</h1>
        </div>
        </nav>

    );
  }
  
  export default tierHeader;
  